<template>
  <div class="config">
    <v-card class="elevation-0" ref="container">
      <v-card-text>
        <!-- <v-row style="height: 100%">
          <v-col cols="6">
            <v-overlay :value="loading">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
            <v-textarea v-model="form.config" label="Config" rows="10" />
            <v-btn color="primary" @click="saveConfig">SAVE</v-btn>
          </v-col>
          <v-col cols="6">
            <div v-if="missingConfigNodes.length">
              <p class="font-weight-bold">Missing Config Nodes:</p>
              <p>{{ missingConfigNodes.join(", ") }}</p>
            </div>
            <v-treeview :items="configTree" activatable></v-treeview>
          </v-col>
        </v-row> -->

        <v-overlay :value="loading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div
          :style="`max-height: ${scrollableHeight}px`"
          class="overflow-y-auto"
        >
          <json-editor :obj-data="form.configJSON" v-model="form.configJSON" />
        </div>
        <v-btn class="mt-5" color="primary" @click="saveConfig">SAVE</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { FirmService } from "@/services/firm.service";

export default {
  data: () => ({
    form: {
      assessmentPeriod: "",
      targetInspectionCount: "",
      fyStartMonth: "",
      selectOptions: [],
      config: "{}",
      configJSON: {},
    },
    configDefault: {
      fy_start_month: "JUN",
      assessment_period: "MONTHLY",
      target_inspection_count: 80,
      mission_custom_fields: [
        {
          code: "region",
          name: "Region",
          type: "select",
          options: ["North", "South", "West"],
          sort: 1,
          search: true,
        },
        {
          code: "weight_start",
          name: "Full Weight",
          type: "text",
          sort: 2,
          required: true,
        },
        {
          code: "weight_end",
          name: "Decanted Weight",
          type: "text",
          sort: 3,
          required: true,
        },
        {
          code: "weight_empty",
          name: "Empty Weight",
          type: "text",
          sort: 4,
          required: true,
        },
      ],
      asset_types: [
        {
          code: "CPIT",
          name: "Catchpits",
        },
        {
          code: "WTRD",
          name: "Water Treatment Devices",
        },
      ],
      colleagues: [
        {
          id: 1,
          first_name: "Adrian Kooiman",
        },
        {
          id: 2,
          first_name: "Angela Curson",
        },
      ],
    },
    scrollableHeight: 0,
    loading: false,
  }),
  computed: {
    ...mapState({
      config: (state) => state.config.config,
    }),
    configTree() {
      return this.getTree(this.form.config ? JSON.parse(this.form.config) : []);
    },
    missingConfigNodes() {
      const keys = this.config ? Object.keys(this.config.data) : [];
      const keysDefault = Object.keys(this.configDefault);
      return keysDefault.filter((key) => !keys.includes(key));
    },
  },
  mounted() {
    this.setScrollableHeight();
    this.fetchConfig();
  },
  methods: {
    setScrollableHeight() {
      setTimeout(() => {
        const containerHeight = this.$refs.container.$el.clientHeight;
        this.scrollableHeight = containerHeight - 32 - 56;
      }, 500);
    },
    setForm() {
      // if (!this.config) return;

      // this.form = {
      //   assessmentPeriod: this.config.config.assessment_period,
      //   targetInspectionCount: this.config.config.target_inspection_count,
      //   fyStartMonth: this.config.config.fy_start_month,
      //   selectOptions: this.config.config.select_options || [],
      //   config: JSON.stringify({
      //     ...this.configDefault,
      //     ...this.config.config,
      //   }),
      // };

      this.form = {
        config: JSON.stringify({
          ...this.configDefault,
          ...(this.config ? this.config.data : {}),
        }),
        configJSON: {
          ...this.configDefault,
          ...(this.config ? this.config.data : {}),
        },
      };
    },
    async fetchConfig() {
      try {
        this.loading = true;
        // await this.$store.dispatch("config/fetchConfig");
        this.setForm();
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async saveConfig() {

      // This deliberately disabled for now since it still relies
      // on the vuex config object actually being a firm object.
      this.$store.commit('snacktime', {
        text: "Failed to save config.",
        color: 'danger',
      });
      return;

      try {
        this.loading = true;

        // const data = {
        //   config: {
        //     assessment_period: this.form.assessmentPeriod,
        //     target_inspection_count: this.form.targetInspectionCount,
        //     fy_start_month: this.form.fyStartMonth,
        //     select_options: this.form.selectOptions,
        //   },
        // };
        const data = {
          // data: JSON.parse(this.form.config),
          data: this.form.configJSON,
        };

        let firm = null;

        if (this.config) {
          firm = await FirmService.update(
            this.config.id,
            data
          ).then((response) => denormalize(response.data));
        } else {
          firm = await FirmService.create({
            third_party_id: 8,
            ...data,
          }).then((response) => denormalize(response.data));
        }

        this.$store.commit("config/setConfig", firm);
        this.$store.commit("snacktime", {
          text: "Config has been saved.",
        });
      } catch (err) {
        console.log(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },
    getTree(nodes) {
      const tree = [];
      const keys = Object.keys(nodes);

      keys.forEach((key, index) => {
        const value = nodes[key];

        if (typeof value === "object") {
          tree.push({
            id: `${key}-${index}`,
            name: `${key} :`,
            children: this.getTree(value),
          });
        } else {
          tree.push({
            id: `${key}-${index}`,
            name: `${key} : ${value}`,
          });
        }
      });

      return tree;
    },
  },
};
</script>

<style lang="scss">
.config {
  height: 100%;

  .v-card {
    height: 100%;

    .v-card__text {
      height: 100%;
    }
  }
}
</style>
